import { Routes, Route } from 'react-router-dom'
import AppLayout from './components/layout/AppLayout'
import Home from './pages/Home'
import Privacidad from './pages/Privacidad'
import Terminos from './pages/Terminos'
import NotFound from './pages/NotFound'

/**
 * App router — F4 Web institucional FITLAB.
 * Rutas públicas (cero PHI). SEO completo se arma D10.
 */
export default function App() {
  return (
    <Routes>
      <Route element={<AppLayout />}>
        <Route index element={<Home />} />
        <Route path="privacidad" element={<Privacidad />} />
        <Route path="terminos" element={<Terminos />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  )
}
